import dashboard from './dashboard';
import dashboardTransaction from './dashboardTransaction';
import utilities from './utilities';
import Logo from 'ui-component/Logo';
//import other from './other';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
   // items: [dashboard, pages, utilities, other]
   
    items: [dashboard, dashboardTransaction, utilities]
};

export default menuItems;